// @ts-nocheck
import { computed, ref, toRefs, watch } from "vue";
import { isFunction, pick } from "lodash-es";
import { ElSelect, ElTable, SelectOptionProxy, TableProps, UPDATE_MODEL_EVENT } from "element-plus";

import type { Ref } from "vue";
import { CacheOption } from "./cache-options";

export const useTable = (
  props: any,
  { attrs, emit },
  {
    key,
    table
  }: {
    select: Ref<InstanceType<typeof ElSelect> | undefined>;
    table: Ref<InstanceType<typeof ElTable> | undefined>;
    key: Ref<string>;
    currentPage: Ref<number>;
  }
) => {
  const data = ref([]);
  const originData = ref([]);

  watch(
    () => props.data,
    (value) => {
      data.value = value;
      originData.value = value;
    },
    {
      immediate: true,
      deep: true
    }
  );

  const optionProxy: Record<string | number, SelectOptionProxy> = {};
  const cacheOptions = computed(
    () => {
      const options: CacheOption[] = [];
      const { label, value } = props.props;
      data.value?.forEach?.((item: any) => {
        options.push({
          value: item[value],
          currentLabel: item[label],
          isDisabled: isFunction(props.props?.disabled)
            ? props.props?.disabled?.(item)
            : item[props.props?.disabled]
        });
      });
      return options;
    },
    {
      immediate: true
    }
  );

  const cacheOptionsMap = computed(() => {
    // @ts-ignore
    return cacheOptions.value.reduce((prev, next) => ({ ...prev, [next.value]: next }), {});
  });
  const setOptionProxy = (key: string | number, vm: SelectOptionProxy) => {
    optionProxy[key] = vm;
  };

  const filter = (query) => {
    if (query) {
      data.value = originData.value.filter((item) =>
        item[props.props.label].toLowerCase().includes(query.toLowerCase())
      );
    } else {
      data.value = originData.value;
    }
  };
  const result: TableProps<any> = {
    ...pick(toRefs(props), Object.keys(ElTable.props)),
    size: "small",
    data: data,
    border: true,
    highlightCurrentRow: props.multiple ? false : true,
    rowKey: key,
    rowClassName: ({ row }: any) => {
      if (isFunction(props.props?.disabled)) {
        if (props.props.disabled(row)) {
          return "disabled-row";
        }
      } else if (row[props.props?.disabled]) {
        return "disabled-row";
      }
    },
    onRowClick: (row: any, column: any, event: any) => {
      attrs.onRowClick?.(row, column, event);
      optionProxy[row[key.value]].selectOptionClick();
      if (props.multiple) {
        table.value?.toggleRowSelection(row);
      }
    },
    onSelectAll: (selection) => {
      emit(
        UPDATE_MODEL_EVENT,
        selection.map((item) => item[key.value])
      );
    }
  };

  return { tableProps: result, setOptionProxy, cacheOptions, cacheOptionsMap, filter };
};
